import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../components/ui/Button";
import ExamContext from "../../../context/ExamContext";
import auth from "../../../services/authServices";
import http from "../../../services/httpServices";
import { printUnit } from "../../../utils/ar";
// import modal from "../../../services/modalServices";
import { isObjectEmpty } from "../../../utils/objects";
import { printFullDateTime } from "../../../utils/time";
import LoadingIcon from "../../../components/ui/LoadingIcon";
import UserInquest from "./UserInquest";
import ExamOpenButton from "./ExamOpenButton";
import { useLanguage } from "../../../context/LanguageContext";

const ExamHome = () => {
    const [previousResults, setPreviousResults] = useState([]);
    const [isExamResultsLoading, setIsExamResultsLoading] = useState(true);
    const [isGettingResultLoading, setIsGettingResultLoading] = useState(false);
    const { id, section_id, exam_id } = useParams();
    const { setIsContinue, setResultId, setForwardedToExam, exam } = useContext(ExamContext);
    const { language } = useLanguage();

    const translations = {
        ar: {
            serial: "السريال",
            entry_date: "تاريخ الدخول",
            total_time: "اجمالي الوقت",
            exam_open_count: "عدد مرات فتح الامتحان",
            time_spent: "الوقت المستهلك",
            total_questions: "اجمالي عدد الاسئلة",
            answered_questions: "عدد الاسئلة المحلولة",
            result: "النتيجة",
            continue_exam: "الاستكمال",
            fetch_result: "انهاء الاختبار \n و الحصول علي النتيجة",
            no_previous_results: "لا يوجد لديك نتائج سابقة...",
            loading_results: "يتم تحميل النتائج السابقة...",
        },
        en: {
            serial: "Serial",
            entry_date: "Entry Date",
            total_time: "Total Time",
            exam_open_count: "Times Opened",
            time_spent: "Time Spent",
            total_questions: "Total Questions",
            answered_questions: "Answered Questions",
            result: "Result",
            continue_exam: "Continue",
            fetch_result: "Finish Exam \n and Get Result",
            no_previous_results: "No previous results...",
            loading_results: "Loading previous results...",
        },
        de: {
            serial: "Seriennummer",
            entry_date: "Eintrittsdatum",
            total_time: "Gesamtzeit",
            exam_open_count: "Anzahl der Öffnungen",
            time_spent: "Verbrauchte Zeit",
            total_questions: "Gesamtzahl der Fragen",
            answered_questions: "Beantwortete Fragen",
            result: "Ergebnis",
            continue_exam: "Fortsetzen",
            fetch_result: "Test beenden \n und Ergebnis erhalten",
            no_previous_results: "Keine vorherigen Ergebnisse...",
            loading_results: "Vorherige Ergebnisse werden geladen...",
        },
    };
    const navigate = useNavigate();
    const getPreviousResults = async () => {
        const token = auth.getToken();
        const config = auth.getAdminAuthConfig(token);
        try {
            const { data: repsone } = await http.get(
                `/api/sellables/course/${id}/sections/${section_id}/sectionables/exams/${exam_id}/exam_results`,
                config
            );
            setIsExamResultsLoading(false);
            setPreviousResults(repsone);
        } catch ({ response }) {}
    };

    const handleGoToQuestion = () => {
        setForwardedToExam(true);
        navigate("questions/0");
    };

    const handleContinue = async (resultId) => {
        setIsContinue(true);
        setForwardedToExam(true);
        setResultId(resultId);
        navigate("questions/0");
    };

    const getResultResult = async (resultId) => {
        setIsGettingResultLoading(true);
        const token = auth.getToken();
        const config = auth.getAdminAuthConfig(token);
        try {
            const { data: repsone } = await http.post(
                `/api/sellables/course/${id}/sections/${section_id}/sectionables/exams/${exam_id}/exam_results/${resultId}/finish`,
                {},
                config
            );
            let updatedPreviousExamResults = previousResults.map((result) => {
                if (result.id === resultId) {
                    result.result = repsone.result;
                }
                return result;
            });
            setPreviousResults(updatedPreviousExamResults);
            setIsGettingResultLoading(false);
        } catch ({ response }) {}
    };
    useEffect(() => {
        getPreviousResults();
        // getExam();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="px-5 py-10 overflow-auto">
            {isExamResultsLoading ? (
                <>
                    <div className="w-full flex-center-both">
                        <div className="rounded-md border bg-third-container border-secondary-container smooth clr-text-primary flex-center-both p-10 space-x-2 space-x-reverse">
                            <div className="font-h1 text-blue-500 flex-center-both">
                                <LoadingIcon />
                            </div>
                            <div>{translations[language].loading_results}</div>
                        </div>
                    </div>
                </>
            ) : previousResults.length > 0 && !isObjectEmpty(exam) ? (
                <table className="table-auto w-full table-style">
                    <thead className="py-10">
                        <tr>
                            <th className="h-20 text-center">{translations[language].serial}</th>
                            <th className="h-20 text-center">
                                {translations[language].entry_date}
                            </th>
                            <th className="h-20 text-center">
                                {translations[language].total_time}
                            </th>
                            <th className="h-20 text-center">
                                {translations[language].exam_open_count}
                            </th>
                            <th className="h-20 text-center">
                                {translations[language].time_spent}
                            </th>
                            <th className="h-20 text-center">
                                {translations[language].total_questions}
                            </th>
                            <th className="h-20 text-center">
                                {translations[language].answered_questions}
                            </th>
                            <th className="h-20 text-center">{translations[language].result}</th>
                            <th className="h-20 text-center"></th>
                        </tr>
                    </thead>
                    <tbody className="py-10">
                        {previousResults.map((result) => {
                            return (
                                <tr key={result.id}>
                                    <td className="h-20 text-center">{result.id}</td>
                                    <td className="h-20 text-center">
                                        {printFullDateTime(result.created_at, language)}
                                    </td>
                                    <td className="h-20 text-center">
                                        {printUnit(result.duration, "دقيقة", language)}
                                    </td>
                                    <td className="h-20 text-center">
                                        {printUnit(result.times_opened, "مرة", language)}
                                    </td>
                                    <td className="h-20 text-center">
                                        {result.time_spent < 60
                                            ? printUnit(result.time_spent, "ثانية", language)
                                            : printUnit(
                                                  parseInt(result.time_spent / 60),
                                                  "دقيقة",
                                                  language
                                              )}
                                    </td>
                                    <td className="h-20 text-center">
                                        {result.questions_quantity}
                                    </td>
                                    <td className="h-20 text-center">{result.is_selected_count}</td>
                                    <td className="h-20 text-center">
                                        {!result.result && result.result !== 0 ? (
                                            <Button
                                                className="font-smaller"
                                                onClick={() => {
                                                    getResultResult(result.id);
                                                }}
                                                isLoading={isGettingResultLoading}
                                            >
                                                {translations[language].fetch_result}
                                            </Button>
                                        ) : (
                                            result.result
                                        )}{" "}
                                    </td>

                                    <td className="h-20 text-center">
                                        {!result.is_finished && exam.sectionable.is_continuable ? (
                                            <Button
                                                color="blue"
                                                onClick={() => handleContinue(result.id)}
                                            >
                                                {translations[language].continue_exam}
                                            </Button>
                                        ) : (
                                            ""
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            ) : (
                <div className="font-w-bold flex-center-both">
                    <div className="px-5 py-1 rounded-full bg-primary-container smooth border-2 border-rose-500 font-h3 text-rose-500">
                        {translations[language].no_previous_results}
                    </div>
                </div>
            )}
            <div className="my-10 font-h3 flex-center-both">
                {(exam.sectionable && exam.sectionable.has_pre_exam_inquest) ||
                (exam.sectionable && exam.sectionable.has_pre_exam_inquest_answered) ? (
                    <UserInquest
                        handleGoToQuestion={handleGoToQuestion}
                        previousResults={previousResults}
                    />
                ) : (
                    <ExamOpenButton
                        previousResults={previousResults}
                        handleGoToQuestion={handleGoToQuestion}
                    />
                )}
            </div>
        </div>
    );
};

export default ExamHome;
